<div *ngIf="releaseSettings != null" class="container-fluid">
  <div mat-dialog-title>
    <div i18n *ngIf="releaseSettings.releaseSettings_ID">Edit Release Info</div>
    <div i18n *ngIf="!releaseSettings.releaseSettings_ID">Add Release Info</div>
  </div>
  <div mat-dialog-content>
    <div class="form-inline mb-2">
      <span i18n *ngIf="!releaseSettings.releaseSettings_ID">To add new release info, complete the form below then click Submit.</span>
      <span i18n *ngIf="releaseSettings.releaseSettings_ID">Make the necessary changes on the form below then click Submit.</span>
      <span class="float-right warning" i18n>
        * Required Information
      </span>
    </div>
    <form #form="ngForm" (ngSubmit)="saveRelease(form)">
      <div class="form-group row">
        <label for="releaseSettingsDescription" class="col-sm-3 col-form-label" i18n><span class="warning">* </span>Description</label>
        <div class="col-sm-9">
          <input name="releaseSettingsDescription" id="releaseSettingsDescription" maxlength="100" required
                 [(ngModel)]="releaseSettings.releaseSettings_Description" #releaseDescription="ngModel"
                 class="form-control" />
          <div [hidden]="!form.submitted || releaseDescription.valid"
               class="alert alert-danger" i18n>
            Enter a release description
          </div>
        </div>
      </div>
      <div class="form-group row">
        <label for="release_Notification" class="col-sm-3 col-form-label" i18n><span class="warning">* </span>Notification Message</label>
        <div class="col-sm-9">
          <textarea name="releaseNotification" id="releaseNotification" maxlength="300" required
                    [(ngModel)]="releaseSettings.releaseSettings_NotificationMessage" #releaseNotificationMessage="ngModel"
                    class="form-control" rows="3"></textarea>

          <div [hidden]="!form.submitted || releaseNotificationMessage.valid"
               class="alert alert-danger" i18n>
            Enter a Notification Message
          </div>
        </div>
      </div>
      <div class="form-group row">
        <label for="release_HTML_bullets" class="col-sm-3 col-form-label" i18n><span class="warning">* </span>Release Details</label>
        <div class="col-sm-9">
          <textarea name="releaseSettings_HTML_Bullets" id="releaseSettings_HTML_Bullets" required
                    [(ngModel)]="releaseSettings.releaseSettings_HTML_Bullets" #releaseDetails="ngModel"
                    class="form-control" rows="3"></textarea>
          <div [hidden]="!form.submitted || releaseDetails.valid"
               class="alert alert-danger" i18n>
            Enter the release details
          </div>
        </div>
      </div>
      <div class="form-group row">
        <label for="release_HTML_bullets" class="col-sm-3 col-form-label" i18n><span class="warning">* </span>Release Summary</label>
        <div class="col-sm-9">
          <textarea name="releaseSettings_Summary" id="releaseSettings_Summary" required
                    [(ngModel)]="releaseSettings.releaseSettings_Summary" #releaseSummary="ngModel"
                    class="form-control" rows="3"></textarea>
          <div [hidden]="!form.submitted || releaseSummary.valid"
               class="alert alert-danger" i18n>
            Enter the release summary
          </div>
        </div>
      </div>
      <div class="form-group" row>
        <label for="note" class="col-sm-3 col-form-label" i18n>Show Notification</label>
        <span class="col-sm-9">
          <mat-checkbox class="col-form-label" id="showNotification" name="showNotification" [(ngModel)]="releaseSettings.releaseSettings_ShowNotification"></mat-checkbox>
        </span>
      </div>
      <div class="form-group row">
        <label for="note" class="col-sm-3 col-form-label" i18n><span class="warning">* </span>Release Notes Attachment</label>
        <div class="col-sm-9">
          <div class="custom-file">
            <app-file-upload [(fileBytes)]="fileBytes" [(importFile)]="importFile"></app-file-upload>
            {{releaseSettings.releaseSettings_FileName}}
          </div>
        </div>
      </div>
      <!--<div [hidden]="!form.submitted || #form.valid"
     class="alert alert-danger" i18n>Validation issues encountered</div>-->
      <div class="row">
        <mat-dialog-actions align="end">
          <button type="submit" value="submit" name="submit" id="submit" class="btn btn-bidit-submit btn-md mr-3" [disabled]="isRequesting" i18n>Submit</button>
          <a (click)="onNoClick()" class="btn btn-bidit-cancel btn-md" i18n>Cancel</a>
        </mat-dialog-actions>
        <!--<app-spinner [isRunning]="isRequesting"></app-spinner>-->
      </div>
    </form>
  </div>
</div>
